import axiosConfig from '@ictlife/merchant/config/axiosConfig';

export const logInUserViaGoogle = async payload => {
  const response = await axiosConfig.post('/google/auth', payload);

  return response;
};
